import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { MechanicDataContainer, MechanicFormContainer, UsersListContainer } from './styles'
import 'react-data-table-component-extensions/dist/index.css'
import Button from '@mui/material/Button'
import * as UsersService from '../../../../services/users'
import DataTable from 'react-data-table-component'
import DataTableExtensions from 'react-data-table-component-extensions'
import { Autocomplete, TextField, Typography, MenuItem } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import * as StatesService from '../../../../services/statesAndCities'
import * as MechanicsService from '../../../../services/mechanics'
import { useModalContext } from '../../../../contexts/ModalContext'
import NewUserModal from './NewUserModal'
import ConfirmationModal from '../../../../components/ui/ConfirmationModal'
import { styled } from '@mui/material/styles'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
})

const MechanicData = ({ mechanic }) => {
    const { setModal } = useModalContext()
    const [confModal, setConfModal] = useState({
        open: false,
        choice: 'remove',
        userId: null
    })

    const [users, setUsers] = useState([])

    const [editMode, setEditMode] = useState(false)

    const [name, setName] = useState(mechanic.name)
    const [address, setAddress] = useState(mechanic.address)
    const [neighborhood, setNeighborhood] = useState(mechanic.neighborhood || '')
    const [cep, setCep] = useState(mechanic.cep || '')
    const [bandeira, setBandeira] = useState(mechanic.bandeira || '')
    const [placeId, setPlaceId] = useState(mechanic.placeId || '')
    const [latitude, setLatitude] = useState(mechanic.latitude || '')
    const [longitude, setLongitude] = useState(mechanic.longitude || '')
    const [establishmentType, setEstablishmentType] = useState(mechanic.type || '')
    const [state, setState] = useState(mechanic.state)
    const [city, setCity] = useState(mechanic.city)
    const [phone, setPhone] = useState(mechanic.phone || '')

    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    // Logo upload states
    const [logoFile, setLogoFile] = useState(null)
    const [logoPreview, setLogoPreview] = useState(null)
    const [isUploadingLogo, setIsUploadingLogo] = useState(false)

    useEffect(() => {
        fetchUsers()
    }, [mechanic.id])

    async function fetchUsers() {
        const users = await UsersService.getMechanicUsersByMechanicId(mechanic.id)
        users.map((u) => {
            return (u.role = u.role === 'ROLE_USER_MECHANIC' ? 'USER' : 'ADMIN')
        })
        setUsers(users)
    }

    useEffect(() => {
        async function getStates() {
            const response = await StatesService.getStates()
            setStates(response)
        }

        getStates()
    }, [])

    useEffect(() => {
        async function getCities() {
            const response = await StatesService.getCities(state)
            setCities(response)
        }

        getCities()
    }, [state])

    const cancelEditMode = () => {
        setName(mechanic.name)
        setAddress(mechanic.address)
        setNeighborhood(mechanic.neighborhood || '')
        setCep(mechanic.cep || '')
        setBandeira(mechanic.bandeira || '')
        setPlaceId(mechanic.placeId || '')
        setLatitude(mechanic.latitude || '')
        setLongitude(mechanic.longitude || '')
        setEstablishmentType(mechanic.type || '')
        setState(mechanic.state)
        setCity(mechanic.city)
        setPhone(mechanic.phone || '')
        setEditMode(false)
    }

    const handleUpdate = async (event) => {
        event.preventDefault()

        const body = {
            name,
            address,
            neighborhood,
            cep,
            bandeira,
            placeId,
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude),
            establishmentType,
            state,
            city,
            phone
        }

        await MechanicsService.updateMechanic(mechanic.id, body)
            .then(() => {
                alert('Mecânica atualizada')
                setEditMode(false)
            })
            .catch(() => alert('Erro ao atualizar esta mecânica!'))
    }

    const handleDeleteUser = async () => {
        if (confModal.userId === null) return

        await UsersService.deleteUser(confModal.userId)
            .then((x) => {
                fetchUsers()
                setConfModal(false)
                alert(`Usuário deletado com sucesso!`)
            })
            .catch(() => alert(`Erro ao deletar este Usuário!`))
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        if (file) {
            setLogoFile(file)
            // Create preview URL
            const previewUrl = URL.createObjectURL(file)
            setLogoPreview(previewUrl)
        }
    }

    const removeLogo = () => {
        setLogoFile(null)
        if (logoPreview) {
            URL.revokeObjectURL(logoPreview)
            setLogoPreview(null)
        }
    }

    const handleLogoUpload = async () => {
        if (!logoFile) {
            alert('Por favor, selecione um arquivo de logo primeiro.')
            return
        }

        setIsUploadingLogo(true)

        try {
            await MechanicsService.saveMechanicLogo(mechanic.id, logoFile)
            alert('Logo atualizado com sucesso!')
            removeLogo() // Clear the selected file after successful upload
        } catch (error) {
            console.error('Error uploading logo:', error)
            alert('Erro ao fazer upload do logo')
        } finally {
            setIsUploadingLogo(false)
        }
    }

    const columns = [
        {
            id: 'name',
            name: 'Nome',
            selector: (row) => row.name,
            sortable: true
        },
        {
            name: 'Email',
            selector: (row) => row.email
        },
        {
            name: 'Permissão',
            selector: (row) => row.role
        },
        {
            name: 'Ação',
            cell: (row) => (
                <Button
                    id={row.ID}
                    variant='outlined'
                    onClick={() => setConfModal({ open: true, choice: 'remove', userId: row.id })}
                >
                    <Delete />
                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        }
    ]

    return (
        <MechanicFormContainer>
            <form onSubmit={handleUpdate}>
                <MechanicDataContainer>
                    <Typography fontSize={18}>Detalhes</Typography>
                    <TextField
                        value={name}
                        name='name'
                        label='Nome'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setName(event.target.value)}
                        variant='outlined'
                        required
                    />
                    <TextField
                        value={address}
                        name='address'
                        label='Endereço'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setAddress(event.target.value)}
                        variant='outlined'
                        required
                    />
                    <TextField
                        value={neighborhood}
                        name='neighborhood'
                        label='Bairro'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setNeighborhood(event.target.value)}
                        variant='outlined'
                    />
                    <TextField
                        value={cep}
                        name='cep'
                        label='CEP'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setCep(event.target.value)}
                        variant='outlined'
                    />
                    <TextField
                        value={bandeira}
                        name='bandeira'
                        label='Bandeira (apenas para postos)'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setBandeira(event.target.value)}
                        variant='outlined'
                    />
                    <TextField
                        value={placeId}
                        name='placeId'
                        label='Place ID'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setPlaceId(event.target.value)}
                        variant='outlined'
                        required
                    />
                    <TextField
                        value={latitude}
                        name='latitude'
                        label='Latitude'
                        type='number'
                        InputProps={{ readOnly: !editMode, step: 'any' }}
                        onChange={(event) => setLatitude(event.target.value)}
                        variant='outlined'
                        required
                    />
                    <TextField
                        value={longitude}
                        name='longitude'
                        label='Longitude'
                        type='number'
                        InputProps={{ readOnly: !editMode, step: 'any' }}
                        onChange={(event) => setLongitude(event.target.value)}
                        variant='outlined'
                        required
                    />
                    {editMode ? (
                        <TextField
                            select
                            name='establishmentType'
                            label='Tipo de Estabelecimento'
                            variant='outlined'
                            onChange={(event) => setEstablishmentType(event.target.value)}
                            required
                            value={establishmentType}
                        >
                            <MenuItem value='MECHANIC'>Mecânica / Oficina</MenuItem>
                            <MenuItem value='GAS_STATION'>Posto de Gasolina</MenuItem>
                            <MenuItem value='CAR_WASH'>Lavagem de Carros</MenuItem>
                            <MenuItem value='PARKING'>Estacionamento</MenuItem>
                        </TextField>
                    ) : (
                        <TextField
                            value={
                                {
                                    MECHANIC: 'Mecânica / Oficina',
                                    GAS_STATION: 'Posto de Gasolina',
                                    CAR_WASH: 'Lavagem de Carros',
                                    PARKING: 'Estacionamento'
                                }[establishmentType] || establishmentType
                            }
                            name='establishmentType'
                            label='Tipo de Estabelecimento'
                            InputProps={{ readOnly: true }}
                            variant='outlined'
                        />
                    )}
                    <TextField
                        value={state}
                        name='state'
                        label='Estado'
                        InputProps={{ readOnly: !editMode }}
                        variant='outlined'
                        style={{ width: '100%' }}
                        required
                    />
                    <TextField
                        value={city}
                        name='city'
                        label='Cidade'
                        InputProps={{ readOnly: !editMode }}
                        variant='outlined'
                        style={{ width: '100%' }}
                        required
                    />
                    <TextField
                        value={phone}
                        name='phone'
                        label='Telefone'
                        InputProps={{ readOnly: !editMode }}
                        onChange={(event) => setPhone(event.target.value)}
                        variant='outlined'
                    />

                    {/* Logo Upload Section */}
                    <Box mt={3} p={2} border={1} borderColor='#e0e0e0' borderRadius={1}>
                        <Typography fontSize={16} mb={2} fontWeight='bold'>
                            Logo do Estabelecimento
                        </Typography>

                        <Box display='flex' flexDirection='column' gap={2}>
                            <Box display='flex' alignItems='center' gap={2} flexWrap='wrap'>
                                <Button
                                    component='label'
                                    variant='outlined'
                                    startIcon={<CloudUploadIcon />}
                                    disabled={isUploadingLogo}
                                    size='small'
                                >
                                    Selecionar Logo
                                    <VisuallyHiddenInput type='file' accept='image/*' onChange={handleFileChange} />
                                </Button>

                                {logoFile && (
                                    <>
                                        <Button
                                            variant='contained'
                                            onClick={handleLogoUpload}
                                            disabled={isUploadingLogo}
                                            size='small'
                                        >
                                            {isUploadingLogo ? 'Enviando...' : 'Atualizar Logo'}
                                        </Button>
                                        <Button
                                            variant='outlined'
                                            color='error'
                                            onClick={removeLogo}
                                            disabled={isUploadingLogo}
                                            size='small'
                                        >
                                            Remover
                                        </Button>
                                    </>
                                )}
                            </Box>

                            {logoFile && (
                                <Box>
                                    <Box mb={1} fontSize='12px' color='#666'>
                                        Arquivo selecionado: {logoFile.name}
                                    </Box>
                                    {logoPreview && (
                                        <Box
                                            component='img'
                                            src={logoPreview}
                                            alt='Preview do logo'
                                            sx={{
                                                maxWidth: 150,
                                                maxHeight: 150,
                                                objectFit: 'contain',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: 1
                                            }}
                                        />
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>

                    <Box width='100%' height='40px' display='flex' justifyContent='right' gap={1}>
                        {!editMode && (
                            <Button variant='text' onClick={() => setEditMode(true)}>
                                Editar
                            </Button>
                        )}
                        {editMode && (
                            <>
                                <Button variant='outlined' type='submit'>
                                    Atualizar
                                </Button>
                                <Button variant='contained' color='error' onClick={() => cancelEditMode()}>
                                    Cancelar
                                </Button>
                            </>
                        )}
                    </Box>
                </MechanicDataContainer>
            </form>
            <UsersListContainer>
                <Box m={1}>
                    <Box display='flex' justifyContent='space-between'>
                        <Typography fontSize={18}>Usuários: {users.length}</Typography>
                        <Button
                            variant='outlined'
                            onClick={() => setModal(<NewUserModal updateTable={fetchUsers} mechanicId={mechanic.id} />)}
                        >
                            <AddIcon fontSize='small' />
                            Usuário
                        </Button>
                    </Box>
                    <DataTableExtensions columns={columns} data={users} export={false} print={false}>
                        <DataTable pagination />
                    </DataTableExtensions>
                </Box>
            </UsersListContainer>
            <ConfirmationModal
                open={confModal.open}
                setOpen={setConfModal}
                title='Deseja deletar este Usuário?'
                subText={`Atenção! Esta ação é irreversível!`}
                handleConfirmation={handleDeleteUser}
            />
        </MechanicFormContainer>
    )
}

export default MechanicData
